// extracted by mini-css-extract-plugin
export default {"containerx":"SubscriptionModal_containerx__GhTE3","cards":"SubscriptionModal_cards__TsVhX"};